import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useSelector } from "react-redux";

// Auth-only: logged-in users get redirected AWAY from these
const AUTH_ONLY_PATHS = ['/login', '/signup', '/forgot-password'];

const PublicRoute = () => {
    const location = useLocation();
    const { loading, isAuthenticated } = useSelector((state) => state.user);

    var redirect = new URLSearchParams(location.search).get('next');
    if (!redirect) {
        redirect = "/dashboard";
    }

    const isAuthOnly = AUTH_ONLY_PATHS.includes(location.pathname);

    return (
        <>
            {loading === false && (
                isAuthenticated && isAuthOnly
                    ? <Navigate to={redirect} />
                    : <Outlet />
            )}
        </>
    );
}

export default PublicRoute;
